import { useState, useCallback } from "react";

/**
 * Supports both standalone (internal state) and controlled (parent passes show/onHide) modals
 * for nested "create entity" flows.
 */
export function useMergedModalVisibility(visibleProp, onHideProp) {
  const [internalVisible, setInternalVisible] = useState(false);
  const isControlled = visibleProp !== undefined;
  const show = isControlled ? visibleProp : internalVisible;

  const open = useCallback(() => {
    if (!isControlled) setInternalVisible(true);
  }, [isControlled]);

  const close = useCallback(() => {
    if (isControlled) onHideProp?.();
    else setInternalVisible(false);
  }, [isControlled, onHideProp]);

  return { show, open, close, isControlled };
}
